'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stage4values = exports.stage3values = exports.getStage2values = undefined;
var _dateToArray = require('@marmalade/date/lib/date-to-array');
var _dateToArray2 = _interopRequireDefault(_dateToArray);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getStage2values = exports.getStage2values = function getStage2values() {
  return {
    claims: 'N',
    convictions: 'N',
    disallowedOccupations: 'N',
    modified: 'N',
    vehicleInsured: 'Y',
    title: '1',
    forenames: 'John',
    surname: 'Smith',
    dateOfBirth: ['25', '12', '2000'],
    licenceStartDate: ['26', '12', '2017'],
    employmentStatus: 'U',
    addressPostcode: 'PE45AG',
    addressLine1: '25 Wainwright',
    addressTownCity: 'Peterborough',
    addressCounty: 'Cambridgeshire',
    email: Date.now() + '.' + Math.random().toFixed(8).slice(2) + '@example.com',
    telephone: '01733123456',
    marketingOptIn: 'N'
  };
};
var stage3values = exports.stage3values = {
  regNo: 'PJ63LXR',
  abiCode: '52123803',
  value: '4190',
  modified: 'N',
  vehiclePurchaseDate: ['08', '2013'],
  mainInsurer: 'Churchill',
  postcodeKeptOvernight: 'PE45AG',
  keptOvernight: '1',
  ownerRelation: '1',
  owner: 'John Smith',
  ownerEmail: 'john.smith@marmalade.co.uk',
  vehicleOwnerPermission: 'N',
  thirdPartyPermission: 'Y',
  thirdPartyName: 'Samual Smith',
  thirdPartyEmail: 'samual.smith@marmalade.co.uk',
  advertiser: '1'
};
var stage4values = exports.stage4values = {
  coverStartDate: (0, _dateToArray2.default)(),
  cover: '30',
  statements: 'Y',
  policySummary: 'Y',
  donation: 'false'
};